// Socket.IO does not automatically retry a namespace middleware rejection.
// Retry with jitter and current credentials, without dropping a session or
// opening a second socket. A logout/socket replacement cancels pending work.
export function createSocketAuthRecovery({ getSocket, getAuthState }) {
  let timer = null;
  let attempts = 0;
  let generation = 0;
  function cancel() {
    if (timer) clearTimeout(timer);
    timer = null;
    attempts = 0;
    generation++;
  }
  function schedule(forceRefresh = false) {
    if (timer || !getAuthState().token) return;
    const socket = getSocket();
    if (!socket || socket.connected) return;
    const rejectedToken = getAuthState().token;
    const epoch = generation;
    const delay = Math.min(30000, 1000 * 2 ** Math.min(attempts++, 5)) * (0.75 + Math.random() * 0.25);
    timer = setTimeout(async () => {
      timer = null;
      if (epoch !== generation || getSocket() !== socket || socket.connected || !getAuthState().token) return;
      try {
        const token = await getAuthState().getValidToken({ reconnectSocket: false, forceRefresh, rejectedToken });
        if (token && epoch === generation && getSocket() === socket && !socket.connected) socket.connect();
      } catch (_) {
        if (epoch === generation && getSocket() === socket) schedule(forceRefresh);
      }
    }, delay);
  }
  return { schedule, cancel };
}
